/**
 * Created by adalto on 5/13/14.
 */


Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.PlannedRoute = function () {

    var _map;
    var _routeId;

    this.setMap = function (map) {
        _map = map;
    };

    this.setRouteId = function (routeId) {
        _routeId = routeId;
    };

    this.drawPlannedRoute = function () {

        if(_routeId) {
            const url = `Route/${_routeId}/EncodedPath?lastUpdate=${new Date().toJSON()}`;

          $.get(url, function (encoded) {
              if (!Monet.Session.RouteDetail.screensList[_routeId]) return;
              const polyline = L.polyline(
                new Monet.PolylineEncoder().decode(encoded, false),
                {
                  color: '#00427C',
                  weight: 2
                }
              );
              polyline.kind = "PLANNED_ROUTE";
              _map.addLayer(polyline);
              polyline.bringToFront();
              Monet.Session.RouteDetail.screensList[_routeId].routeLayer = polyline;
              screen.canShowPlannedRoute = true;
          });
        }

    };

    this.removePlannedRoute = function () {

        var map = _map;

        for (var i in map._layers) {

            if (map._layers[i].kind === "PLANNED_ROUTE") {

                map.removeLayer(map._layers[i]);

            }

        }

    };
};
